import { createAction } from 'redux-actions';
import * as actions from './actions';

export const fetchFlagsRequest = createAction(actions.FETCH_FLAGS_REQUEST);
export const fetchFlagsSuccess = createAction(actions.FETCH_FLAGS_SUCCESS);
export const fetchFlagsFailure = createAction(actions.FETCH_FLAGS_FAILURE);
